import { useCallback, useState } from 'react';
import type { AssetCommandConsoleEntry } from '../types';

export function useOcppCommandConsole() {
  const [entries, setEntries] = useState<AssetCommandConsoleEntry[]>([]);

  /** Newest-first: new entries are inserted at the top. */
  const prepend = useCallback((next: readonly AssetCommandConsoleEntry[]) => {
    setEntries((current) => [...next, ...current]);
  }, []);

  const clear = useCallback(() => {
    setEntries([]);
  }, []);

  return {
    entries,
    prepend,
    clear,
  };
}
